import { PerspectiveCamera } from "three";
import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import MainExperience from "./MainExperience";
import { getDeviceScreen } from "../../utils/utils";

export default class MainCamera {
  constructor() {
    this.experience = new MainExperience();
    this.size = this.experience.sizes;
    this.scene = this.experience.scene;
    this.canvas = this.experience.canvas;
    this.debug = this.experience.debug;

    this.screenSize = getDeviceScreen(window.innerWidth);

    this.setInstance();
    this.setOrbitControls();
  }

  setInstance() {
    this.instance = new PerspectiveCamera(
      35,
      this.size.width / this.size.height,
      0.1,
      1000
    );

    if (this.screenSize === "desktop") {
      this.instance.position.set(10, 0.5, 12);
    } else if (this.screenSize === "tablet") {
      this.instance.position.set(10, 0.3, 18);
    } else if (this.screenSize === "mobile") {
      this.instance.position.set(10, 0.2, 25);
    } else {
      this.instance.position.set(10, 0.5, 30);
    }
    this.instance.lookAt(this.scene.position);
    this.scene.add(this.instance);
  }

  setOrbitControls() {
    this.controls = new OrbitControls(this.instance, this.canvas);
    this.controls.enableDamping = true;
  }

  resize() {
    this.instance.aspect = this.size.width / this.size.height;
    this.instance.updateProjectionMatrix();
  }

  update() {
    this.controls.update();
  }
}
